<template>
  <div class="withdrawal">
    <Tab title="提现" />
    <div class="bank">
      <p>提现至</p>
      <div class="selectBank">
        <img src alt />
        <p>招商银行</p>
        <span>尾号6666</span>
      </div>
      <div class="arrowR">
        <img src="static/img/list_arrow.png" alt />
      </div>
    </div>
    <div class="money">
      <div class="write">
        <p>提现金额</p>
        <input type="number" placeholder="请输入提现金额" />
      </div>
      <span>可提现金额：888.88元</span>
    </div>
    <div class="paypwd">
      <p>支付密码</p>
      <input type="number" placeholder="请输入" />
      <button @click="forget()">忘记密码</button>
    </div>
    <button class="confirm" @click="confirmWithdrawal()">确认提现</button>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
export default {
  data() {
    return {};
  },
  methods: {
    confirmWithdrawal() {
      this.$router.push("/withdrawal/withdrawal_detail");
    },
    forget(){
      this.$router.push("/withdrawal/forget_password");
    }
  },
  components: {
    Tab,
  },
};
</script>

<style lang="scss" scoped>
.withdrawal {
  padding-top: 100px;
  height: 100%;
  width: 100%;
  background: #f4f5f8;
  .bank {
    padding: 10px 30px 0;
    height: 120px;
    display: flex;
    align-items: center;
    background: #fff;
    margin: 1px 0 14px;
    > p {
      height: 45px;
      font-size: 32px;
      color: rgba(153, 153, 153, 1);
      line-height: 45px;
      margin-right: 134px;
    }
    .selectBank {
      display: flex;
      align-items: center;
      img {
        width: 68px;
        height: 68px;
        margin-right: 22px;
        display: block;
      }
      p {
        height: 45px;
        font-size: 32px;
        color: rgba(51, 51, 51, 1);
        line-height: 45px;
        margin-right: 10px;
      }
      span {
        height: 45px;
        font-size: 32px;
        color: rgba(204, 204, 204, 1);
        line-height: 45px;
      }
    }
    .arrowR {
      margin: 0 0 0 auto;
      img {
        width: 12px;
        display: block;
      }
    }
  }
  .money {
    padding: 10px 30px 26px;
    background: #fff;
    margin-bottom: 14px;
    .write {
      height: 110px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e3e3e3;
      p {
        height: 45px;
        font-size: 32px;
        color: rgba(153, 153, 153, 1);
        line-height: 45px;
        margin-right: 102px;
      }
      input {
        flex: 1;
        height: 45px;
        font-size: 32px;
        line-height: 45px;
      }
    }
    > span {
      display: block;
      margin-top: 18px;
      height: 33px;
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 33px;
    }
  }
  .paypwd {
    padding: 13px 30px 0;
    height: 110px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;
    p {
      flex: 1;
      height: 45px;
      font-size: 32px;
      color: rgba(153, 153, 153, 1);
      line-height: 45px;
      margin-right: 102px;
    }
    input {
      width: 312px;
      height: 45px;
      font-size: 32px;
      color: rgba(204, 204, 204, 1);
      line-height: 45px;
    }
    button {
      width: 148px;
      height: 52px;
      font-size: 25px;
      color: rgba(232, 64, 49, 1);
      border-radius: 26px;
      border: 2px solid rgba(232, 64, 49, 1);
      box-sizing: border-box;
    }
  }
  > button {
    font-size: 32px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    width: 690px;
    height: 96px;
    background: rgba(232, 64, 49, 1);
    border-radius: 48px;
    margin: 115px 30px;
    text-align: center;
    line-height: 96px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/withdrawal/withdrawal.vue